import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {CitizensServicesSector} from './citizens-services-sector.model';

export const loadCitizensServicesSectors = createAction(
  '[CitizensServicesSector/API] Load CitizensServicesSectors',
  props<{ citizensServicesSectors: CitizensServicesSector[] }>()
);

export const addCitizensServicesSector = createAction(
  '[CitizensServicesSector/API] Add CitizensServicesSector',
  props<{ citizensServicesSector: CitizensServicesSector }>()
);

export const upsertCitizensServicesSector = createAction(
  '[CitizensServicesSector/API] Upsert CitizensServicesSector',
  props<{ citizensServicesSector: CitizensServicesSector }>()
);

export const addCitizensServicesSectors = createAction(
  '[CitizensServicesSector/API] Add CitizensServicesSectors',
  props<{ citizensServicesSectors: CitizensServicesSector[] }>()
);

export const upsertCitizensServicesSectors = createAction(
  '[CitizensServicesSector/API] Upsert CitizensServicesSectors',
  props<{ citizensServicesSectors: CitizensServicesSector[] }>()
);

export const updateCitizensServicesSector = createAction(
  '[CitizensServicesSector/API] Update CitizensServicesSector',
  props<{ citizensServicesSector: Update<CitizensServicesSector> }>()
);

export const updateCitizensServicesSectors = createAction(
  '[CitizensServicesSector/API] Update CitizensServicesSectors',
  props<{ citizensServicesSectors: Update<CitizensServicesSector>[] }>()
);

export const deleteCitizensServicesSector = createAction(
  '[CitizensServicesSector/API] Delete CitizensServicesSector',
  props<{ id: string }>()
);

export const deleteCitizensServicesSectors = createAction(
  '[CitizensServicesSector/API] Delete CitizensServicesSectors',
  props<{ ids: string[] }>()
);

export const clearCitizensServicesSectors = createAction(
  '[CitizensServicesSector/API] Clear CitizensServicesSectors'
);

//CUSTOM

export const citizenGetAllSectors = createAction(
  '[CitizensServicesSector/API]  Get Citizen Service All Sectors',
  props<{filtering?:string}> ()
);



